import { isEmpty } from 'lodash';

import { VehicleOption } from 'models/auto/vehicle';

export const mapAutoResultsSummary = (autoResults: VehicleOption[]): VehicleOption[] => {
  if (isEmpty(autoResults) || autoResults.length === 0) return [];
  const tempResults: { vehicle: VehicleOption; order: number }[] = [];
  const aux = {};
  const origin = [...autoResults];
  const copy = [...autoResults];
  copy.sort((a, b) =>
    a.rates &&
    a.rates[0] &&
    a.rates[0].pricePayNow &&
    a.rates[0].pricePayNow.total &&
    b.rates &&
    b.rates[0] &&
    b.rates[0].pricePayNow &&
    b.rates[0].pricePayNow.total
      ? a.rates[0].pricePayNow.total - b.rates[0].pricePayNow.total
      : 0,
  );
  copy.forEach((option) => {
    if (option && option.company && option.company.code && option.vehicle && option.vehicle.model) {
      aux[option.company.code] = [...(aux[option.company.code] || [])];
      if (!aux[option.company.code].includes(option.vehicle.model)) {
        aux[option.company.code].push(option.vehicle.model);
        tempResults.push({
          vehicle: option,
          order: origin.findIndex((o) => o.optionId === option.optionId),
        });
      }
    }
  });

  tempResults.sort((a, b) => a.order - b.order);
  const results = tempResults.map((o) => o.vehicle);
  return results;
};
